var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("g",{"data-name":"Layer 1"},[React.createElement("path",{"fill":"none","d":"M0 16V0h16v16z","key":0}),React.createElement("path",{"fill":"#53647f","d":"M.929 5.172l5.657 5.656L8 12.243l1.414-1.415 5.657-5.656-1.414-1.415L8 9.414 2.343 3.757.929 5.172z","key":1})])));
}

ChevronDown.defaultProps = {"width":"16","height":"16"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
